module.exports = __webpack_public_path__ + "common/logo-raksul-185282c807d921ef9e070d83f98ccd20.svg";